var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("參數設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("系統資訊")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("系統資訊")])]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.liffUrls,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(liff_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "copy-panel col-2 cursor"
        }, [_c('div', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: data.item.liff_url,
            expression: "data.item.liff_url",
            arg: "copy"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: '已複製',
            expression: "'已複製'",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "copy-button",
          attrs: {
            "id": "copy-tooltip-target"
          },
          on: {
            "click": function click($event) {
              return _vm.clipboardSuccessHandler(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-link-variant",
          attrs: {
            "aria-hidden": "true"
          }
        })])]), _c('div', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: data.item.liff_url,
            expression: "data.item.liff_url",
            arg: "copy"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: '已複製',
            expression: "'已複製'",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "col-2 mr-3",
          on: {
            "click": function click($event) {
              return _vm.clipboardSuccessHandler(data.item);
            }
          }
        }, [_c('a', {
          attrs: {
            "href": "#"
          }
        }, [_vm._v(_vm._s(data.item.liff_url))])])])];
      }
    }])
  })], 1)], 1)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }